// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.lb-pull-refresh__track {\n  min-height: 80vh;\n}\n", ""]);
// Exports
module.exports = exports;
